<template>
    <van-popup v-model="show" mode="center" @click-overlay="close">
        <div class="content">
            <div class="item-balance">
                <div>Saldo Actual</div>
                <div class="item-balance-val1">{{ allBalance }}</div>
            </div>
            <!-- <div class="item-balance">
                <div>Saldo Real</div>
                <div class="item-balance-val2">{{ CurrencyType }} 0</div>
            </div> -->
            <div class="item-balance">
                <div>Saldo de Bonos</div>
                <div class="item-balance-val3">{{ CurrencyType }} {{ useActivityBonusBalance || 0 }}</div>
            </div>
            <div class="btns">
                <div @click="toDeposit">
                    {{ $t("deposit.Deposit") }}
                </div>
                <div @click="toWithdraw">
                    {{ $t("Withdraw.Withdraw") }}
                </div>
            </div>
        </div>
    </van-popup>
</template>

<script>
export default {
    data() {
        return {}
    },
    computed: {
        useActivityBonusBalance() {
            return this.$store.getters.userInfo && this.$store.getters.userInfo.balanceAmtAccount && this.$store.getters.userInfo.balanceAmtAccount.useActivityBonusBalance
        },
        show: {
            get() {
                return this.$store.state.user.isShowBalancePopup
            },
            set(val) {
                return val
            }
        }
    },
    methods: {
        close() {
            this.$store.dispatch('user/setIsShowBalancePopup', false)
        },
        toDeposit() {
            this.close()
            if (this.$route.path.indexOf('/wallet?type=deposit') !== -1) {
                return
            }
            const params = { type: 'deposit' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        },
        toWithdraw() {
            this.close()
            if (this.$route.path.indexOf('/wallet?type=Withdraw') !== -1) {
                return
            }
            const params = { type: 'Withdraw' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.van-popup {
    background: transparent;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    overflow: visible;
}

.content {
    padding: .3rem;
    box-sizing: border-box;
    width: 88vw;
    max-width: 5rem;
    background: $bg-popup-color;
    border-radius: .14rem;
    position: relative;
    color: $font-color;
    font-size: .24rem;
    text-align: center;

    .item-balance {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 700;
        font-size: .28rem;
        height: .48rem;
        color: $font-color;

        .item-balance-val1 {
            color: $font-theme-color;
        }

        .item-balance-val2 {
            color: #00962F;
        }

        .item-balance-val3 {
            color: $font-error-color;
        }
    }

    .btns {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: .3rem;
        gap: .16rem;

        &>div {
            height: .64rem;
            width: calc(50% - .08rem);
            display: flex;
            align-items: center;
            justify-content: center;
            color: $font-title-color;
            font-size: .28rem;
            border-radius: .18rem;
            font-weight: bold;
            cursor: pointer;
            background: linear-gradient(180deg, rgba($bg-box-color, .98) 0%, rgba($bg-shell-color, .98) 100%);
            border: 1px solid rgba($font-label-color, .18);
            box-shadow: inset 0 1px 0 rgba($font-title-color, .06);

            &:first-child {
                background: $bg-home-popup-button-color;
                color: $font-btn-color;
                border-color: $border-home-popup-strong-color;
                box-shadow: $shadow-component-button-color;
            }
        }
    }
}
</style>
